import { TranslationKey, useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityUpdateQuestion } from '../../projectDetailsActivities.models';

export const UpdateQuestionActivity = ({ values }: IProjectActivity<IProjectActivityUpdateQuestion>): ReactElement => {
  const { t } = useTranslator();

  const properties: {
    name: TranslationKey;
    original: string | number | boolean;
    current: string | number | boolean;
  }[] = [];

  if (values.question !== values.originalQuestion) {
    properties.push({
      name: 'activity_description_common.name',
      original: values.originalQuestion,
      current: values.question,
    });
  }
  if (values.answerType !== values.originalAnswerType) {
    properties.push({
      name: 'activity_description_common.answerType',
      original: t(`${values.originalAnswerType}_question_type`),
      current: t(`${values.answerType}_question_type`),
    });
  }
  if (values.order !== values.originalOrder) {
    properties.push({
      name: 'activity_description_common.order',
      original: values.originalOrder,
      current: values.order,
    });
  }
  if (values.isRequired !== values.originalIsRequired) {
    properties.push({
      name: 'activity_description_common.isRequired',
      original: values.originalIsRequired,
      current: values.isRequired,
    });
  }
  return (
    <span>
      {t('activity_description_UpdateQuestion')}
      <b>{values.originalQuestion}</b>
      {t('activity_description_common.changed')}
      {properties.map((x) => t(x.name)).join(', ')} {t('activity_description_common.from')} <b>{properties.map((x) => x.original).join(', ')}</b>{' '}
      {t('activity_description_common.to')} <b>{properties.map((x) => x.current).join(', ')}</b>.
    </span>
  );
};
